module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._v("  \n" + _vm._s(_vm.tile) + "\n        "), _vm._l((_vm.tile.colorConditions), function(condition, index) {
    return _c('div', [(_vm.tile.value >= condition.minValue & _vm.tile.value < condition.maxValue) ? _c('div', [(_vm.tile.width == 'Small') ? _c('div', {
      staticClass: "col-lg-2"
    }, [_c('a', {
      staticClass: "block block-link-hover3"
    }, [_c('div', {
      staticClass: "block-content block-content-full clearfix",
      style: ({
        backgroundColor: condition.colorBackground
      })
    }, [_c('i', {
      staticClass: "fa-2x text-white pull-right",
      class: _vm.tile.favIcon
    }), _vm._v(" "), _c('span', {
      staticClass: "h6 font-w700 text-white-op"
    }, [_vm._v(_vm._s(_vm.tile.value))]), _vm._v(" "), _c('span', {
      staticClass: "h6 text-white-op"
    }, [_vm._v(_vm._s(_vm.tile.label))])])])]) : _vm._e(), _vm._v(" "), (_vm.tile.width == 'Medium') ? _c('div', {
      staticClass: "col-lg-3"
    }, [_c('a', {
      staticClass: "block block-link-hover3"
    }, [_c('div', {
      staticClass: "block-content block-content-full clearfix",
      style: ({
        backgroundColor: condition.colorBackground
      })
    }, [_c('i', {
      staticClass: "fa-2x text-white pull-right",
      class: _vm.tile.favIcon
    }), _vm._v(" "), _c('span', {
      staticClass: "h6 font-w700 text-white-op"
    }, [_vm._v(_vm._s(_vm.tile.value))]), _vm._v(" "), _c('span', {
      staticClass: "h6 text-white-op"
    }, [_vm._v(_vm._s(_vm.tile.label))])])])]) : _vm._e(), _vm._v(" "), (_vm.tile.width == 'Large') ? _c('div', {
      staticClass: "col-lg-4"
    }, [_c('a', {
      staticClass: "block block-link-hover2 text-center"
    }, [_c('div', {
      staticClass: "block-content block-content-full",
      style: ({
        backgroundColor: condition.colorBackground
      })
    }, [_c('div', {
      staticClass: "font-w600 text-white-op push-5-t"
    }, [_vm._v(_vm._s(_vm.tile.label))]), _vm._v(" "), _c('i', {
      staticClass: "fa-2x text-white",
      class: _vm.tile.favIcon
    }), _vm._v(" "), _c('div', {
      staticClass: "h4 text-white"
    }, [_vm._v(_vm._s(_vm.tile.value) + " " + _vm._s(_vm.tile.valueSufix))])])])]) : _vm._e(), _vm._v(" "), (_vm.tile.width == 'Full') ? _c('div', {
      staticClass: "col-lg-12"
    }, [_c('a', {
      staticClass: "block block-link-hover3"
    }, [_c('div', {
      staticClass: "block-content block-content-full clearfix",
      style: ({
        backgroundColor: condition.colorBackground
      })
    }, [_c('i', {
      staticClass: "fa-2x text-white pull-right",
      class: _vm.tile.favIcon
    }), _vm._v(" "), _c('span', {
      staticClass: "h6 font-w700 text-white-op"
    }, [_vm._v(_vm._s(_vm.tile.value))]), _vm._v(" "), _c('span', {
      staticClass: "h6 text-white-op"
    }, [_vm._v(_vm._s(_vm.tile.label))])])])]) : _vm._e()]) : _vm._e()])
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71349a22","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/custom_dashboard/SubComponent/CustomDashboardTileV1p00.vue
// module id = 1565
// module chunks = 4